// ag-grid-react v22.1.1
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var counter = 0;

function generateNewKey() {
  return "agPortalKey_" + ++counter;
}

exports.default = generateNewKey;